import { render, staticRenderFns } from "./RegionChooseDialog.vue?vue&type=template&id=3678bb1e&scoped=true"
import script from "./RegionChooseDialog.vue?vue&type=script&lang=js"
export * from "./RegionChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./RegionChooseDialog.vue?vue&type=style&index=0&id=3678bb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678bb1e",
  null
  
)

export default component.exports